<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Tågnummer från"
        outlined
        type="number"
        v-model.number="model.train_number_from"
        :rules="[required]"
      />
    </v-col>
    <v-col>
      <v-text-field
        label="Tågnummer till"
        outlined
        type="number"
        v-model.number="model.train_number_to"
        :rules="[required]"
      />
    </v-col>
    <slot />
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'

export default {
  name: 'TurnaroundTrainNumberFields',

  data: () => ({
    required
  }),

  computed: {
    model: sync('turnaround/model')
  }
}
</script>
